import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import React from 'react'

function BedbankMobileOnlyPriceLabel() {
  return <PromotionLabel variant="premium" icon={<LineMobileAndroidIcon />}>
    Mobile only price
  </PromotionLabel>
}

export default BedbankMobileOnlyPriceLabel
